import { ON_PREMISE_INSTANCES } from '$app-web/constants/custom-features';
import { getEnvironmentName } from '$app-web/utils/environment';

export type TerminologyOverlay = Record<string, string>;
type OverlayLoader = () => Promise<{ default: TerminologyOverlay }>;

// Per-instance wording for domain concepts a customer names differently. An overlay only
// overrides keys that already exist in the namespace bundle; instances without an entry load nothing.
const OVERLAYS: Record<string, Partial<Record<string, OverlayLoader>>> = {
    [ON_PREMISE_INSTANCES.THERAPIST]: {
        rdash: () => import('./overlays/therapist/rdash.json'),
    },
};

export async function getTerminologyOverlay(namespace: string): Promise<TerminologyOverlay | null> {
    const load = OVERLAYS[getEnvironmentName() ?? '']?.[namespace];
    if (!load) {
        return null;
    }

    const { default: overlay } = await load();
    return overlay;
}
